import { METHODOLOGY } from "@/data/content";
import { Reveal, SectionHeader } from "@/components/Reveal";

const Methodology = () => (
    <section id="methodology" data-testid="methodology-section" className="scroll-mt-24 relative overflow-hidden bg-grid-dark t-bg py-14 md:py-24">
        <div className="animate-aurora-slow motion-reduce:[animation:none] pointer-events-none absolute -right-52 top-[-15%] h-[32rem] w-[32rem] rounded-full bg-electric/7 blur-[140px]" aria-hidden="true" />
        <div className="container-x relative">
            <Reveal>
                <SectionHeader
                    eyebrow="How Varasun Works"
                    title="The Varasun transformation framework"
                    intro="A connected journey — from first diagnostic to continuously operated environments. Six chapters, one accountable partner."
                />
            </Reveal>

            <div className="mt-12 grid gap-x-10 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
                {METHODOLOGY.map((m, i) => (
                    <Reveal key={m.num} delay={(i % 3) * 0.1}>
                        <div className="group border-t t-border pt-8 transition-colors duration-300 hover:border-electric">
                            <p className="font-mono text-sm font-semibold tracking-[0.25em] text-electric">{m.num}</p>
                            <h3 className="mt-4 font-display text-2xl font-semibold tracking-tight t-heading md:text-3xl">
                                {m.title}
                            </h3>
                            <p className="mt-3 max-w-sm text-sm leading-relaxed t-soft">{m.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Methodology;
